<template>
  <v-app color>
    <v-img
      :src="require('@/assets/bg_image.jpg')"
      :lazy-src="require('@/assets/bg_image_blur.jpg')"
      :height="this.$vuetify.breakpoint.height"
    >
      <v-container fill-height class="d-flex justify-center">
        <v-content>
          <v-alert
            border="top"
            colored-border
            type="info"
            elevation="2"
            width="500"
            :tile="true"
            class="mx-auto pa-7"
            icon="mdi-cloud-alert"
          >
            <v-img
              class
              alt="Microsoft Logo"
              :src="require('@/assets/microsoft_logo.svg')"
              transition="scale-transition"
              max-height="108"
              max-width="108"
            />
            <h2 class="my-4">Microsoft Voicemail</h2>
            <vuetify-audio :file="file" color="primary"></vuetify-audio>
            <v-row align="center" no-gutters>
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <router-link to="/microsoft">
                  <v-btn
                    class="rounded-button white--text text-none mt-10"
                    :depressed="true"
                    color="#005DA6"
                  >Continue to inbox</v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-alert>
        </v-content>
      </v-container>
    </v-img>
  </v-app>
</template>
<script>
export default {
  components: {
    VuetifyAudio: () => import("vuetify-audio")
  },
  data: () => ({
    file:
      "https://res.cloudinary.com/dvvr9ncoi/video/upload/v1594140547/voicemail_c0uyep.mp3"
  })
};
</script>